import { render, staticRenderFns } from "./zzmjCov.vue?vue&type=template&id=404ea312&scoped=true"
import script from "./zzmjCov.vue?vue&type=script&lang=js"
export * from "./zzmjCov.vue?vue&type=script&lang=js"
import style0 from "./zzmjCov.vue?vue&type=style&index=0&id=404ea312&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404ea312",
  null
  
)

export default component.exports